import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from "react-bootstrap";
import { Check2All, Cart2 } from "react-bootstrap-icons";
import '../../css/pay.css';
import { useLocation } from 'react-router-dom';


const SuccessPostingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const postingNumber = location.state?.postingNumber;

  return (
    <div className="d-flex flex-column justify-content-center align-items-center  text-center px-3 pt-5 pb-5">
      <CheckCircle size={80}  color="#198754" className="mb-4" />
      <h1 className="fw-bold mb-2">Заказ успешно создан!</h1>
      <p className=" mb-4 pt-2">
        Спасибо за ваш заказ. Мы уже начали его обработку.
      </p>
      {postingNumber && (
          <p className=" mb-4 pt-2">
            Номер отправления: <strong>{postingNumber}</strong>
          </p>
        )}
      <div className="d-flex gap-3 flex-wrap justify-content-center pb-5" >
            <Button
                variant="outline-success"
                className="d-flex align-items-center rounded-4 custom-green-outline"
                onClick={() => navigate('/catalog')}
              >
                <Check2All className="me-2" />
                Вернуться в каталог
            </Button>
            <Button
                        variant="outline-secondary"
                        className="d-flex align-items-center rounded-4 "
                        onClick={() => navigate('/history')}
                      >
                        <Cart2 className="me-2" />
                        К списку заказов
            </Button>
        </div>
    </div>
    
  );
};

export default SuccessPostingPage;